export default __webpack_public_path__ + "static/media/guide-add.e72f2a18.svg";